import { render, staticRenderFns } from "./ModalDeleteDomain.vue?vue&type=template&id=217387e8&"
import script from "./ModalDeleteDomain.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports